export const LEGAL_DOCUMENT_IDS = {
  privacy: 'privacy-policy',
  terms: 'terms-of-use',
  cookies: 'cookie-policy',
  security: 'information-security-policy',
  legalNotice: 'legal-notice',
};

const LEGACY_DOCUMENT_IDS = {
  'politica-privacidad': LEGAL_DOCUMENT_IDS.privacy,
  'condiciones-uso': LEGAL_DOCUMENT_IDS.terms,
  'politica-cookies': LEGAL_DOCUMENT_IDS.cookies,
  'politica-seguridad': LEGAL_DOCUMENT_IDS.security,
  'aviso-legal': LEGAL_DOCUMENT_IDS.legalNotice,
};

export function canonicalizeLegalHash(hash) {
  const normalizedHash = (hash || '').replace(/^#/, '');
  if (!normalizedHash) return '';

  if (LEGACY_DOCUMENT_IDS[normalizedHash]) {
    return LEGACY_DOCUMENT_IDS[normalizedHash];
  }

  const legacySection = Object.entries(LEGACY_DOCUMENT_IDS).find(
    ([legacyId]) =>
      normalizedHash.startsWith(`${legacyId}-seccion-`) ||
      normalizedHash.startsWith(`${legacyId}-section-`)
  );

  if (legacySection) {
    const [legacyId, canonicalId] = legacySection;
    const sectionNumber = normalizedHash.replace(
      new RegExp(`^${legacyId}-(?:seccion|section)-`),
      ''
    );
    return `${canonicalId}-section-${sectionNumber}`;
  }

  return normalizedHash;
}
